export default __webpack_public_path__ + "static/media/img-44.e8041edb.jpg";